export default "__VITE_ASSET__24dbb29a__"